import script from "./OrderDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderDetails.vue?vue&type=script&setup=true&lang=ts"

import "./OrderDetails.vue?vue&type=style&index=0&id=3eeab960&lang=css"

const __exports__ = script;

export default __exports__